<template>
  <div class="home-page-index">
    <page_head class="page-top"></page_head>
    <template v-if="path === '/'">
    <div class="top-img">
      <div class="top-img-content">
        <div>
          <img src="~assets/index/c1.png" alt="">
        </div>
        <div>
          <img src="~assets/index/c2.png" alt="">
        </div>
        <div class="top-img-content-text">
          最大化企业利润的基础上<br>
          最优化管理库存和车队排<br>
          期调度
        </div>
        <a href="javascript:;" class="top-img-content-btn" @click="gowork">
          Have Fun
        </a>
      </div>
    </div>
    <div class="index-content-1">
      <div class="content-1-title">
        专业 / 创新 / 前沿
      </div>
      <div class="content-1-text">
        <div>
          <img src="~assets/index/co1.png" alt="">
        </div>
        <div>
          <img src="~assets/index/co2.png" alt="">
        </div>
        <div>
          <img src="~assets/index/co3.png" alt="">
        </div>
      </div>
      <div class="content-1-text content-1-text-2">
        <div>
          专业的数据分析和<br>数据优化建模团队
        </div>
        <div>
          数据源的整合、网络规划<br>实时监控
        </div>
        <div>
          互联网开放团队，炫酷UI设计<br>厚实高效的算法引擎
        </div>
      </div>
    </div>
    <div class="index-content-2">
      <div class="content-2-title">
        Mii-RO亮点是什么？
      </div>
      <div class="content-2-text">
        <div>
          <img style="width: 55.2em;" src="~assets/index/c2-1.png" alt="">
        </div>
        <div class="conten-2-right">
          <div class="conten-2-right-c">
            <div class="img-text">
              <img src="~assets/index/c2-3.png" alt="">
              <span>强大的优化算法引擎</span>
            </div>
            <strong>+</strong>
            <div  class="img-text">
              <img src="~assets/index/c2-2.png" alt="">
              <span>前沿的用户界面体验</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="index-content-3">
      <div class="content-3-title">
        Mii-RO行业应用
      </div>
      <div class="content-3-text">
        <div>
          <img src="~assets/index/c3-1.png" alt="">
        </div>
        <div>
          <img src="~assets/index/c3-2.png" alt="">
        </div>
        <div>
          <img src="~assets/index/c3-3.png" alt="">
        </div>
        <div>
          <img src="~assets/index/c3-4.png" alt="">
        </div>
        <div>
          <img src="~assets/index/c3-5.png" alt="">
        </div>
        <div>
          <img src="~assets/index/c3-6.png" @click="goSingle">
        </div>
      </div>
    </div>
    <div class="index-content-line">
    </div>
    <div class="index-content-4">
      <div class="content-4-title">
        Mii-RO鲁棒功能组合
      </div>
      <div class="content-4-text">
        <div class="content-4-text-c">
          <div class="content-4-text-title">
            <div><span class="big-text">VRPTW</span>(VRP with time window)</div>
          </div>
          <div class="content-4-text-note">
            即带有时间窗的车辆路径问题。每个客户都可以有对应的要求送达时间窗口，时间窗口可以多个。由于客户数比较多，我们会先把客户分组，然后对每个组求解路径规划模型。
          </div>
          <div class="content-4-text-img">
            <img src="~assets/index/c4-1.png" alt="">
          </div>
        </div>
        <div class="content-4-text-line">
        </div>
        <div class="content-4-text-c">
          <div class="content-4-text-title">
            <div><span class="big-text">MDVRP</span>(Mulit-Depot VRP)</div>
          </div>
          <div class="content-4-text-note">
            即多个仓库的车辆路径问题。同样的货物可以在多个仓库获取，自动分配最优的选择给客户。
          </div>
          <div class="content-4-text-img">
            <img src="~assets/index/c4-2.png" alt="">
          </div>
        </div>
      </div>
      <div class="content-4-text">
        <div class="content-4-text-c">
          <div class="content-4-text-title">
            <div><span class="big-text">Heterogeneous Fleet VRP</span></div>
          </div>
          <div class="content-4-text-note content-4-text-note-2">
            即多种车型的车辆路径问题。<br><br>
            例如：<br>
            重型货车指汽车总质量在12吨以上，车长6米以上。<br>
            中型货车指汽车总质量大于4.5吨、小于12吨，车长小于6米。<br>
            轻型货车指汽车总质量小于等于4.5吨，车长小于6米。<br>
            微型货车指总质量小于1.8吨，车长小于等于3.56米的货车。
          </div>
          <div class="content-4-text-img">
            <img src="~assets/index/c4-3.png" alt="">
          </div>
        </div>
        <div class="content-4-text-line">
        </div>
        <div class="content-4-text-c">
          <div class="content-4-text-title">
            <div><span class="big-text">IRP</span>(Inventory Routing Problem)</div>
          </div>
          <div class="content-4-text-note content-4-text-note-2">
            即与库存结合的车辆路径问题。与客户库存管理结合的补货配送问题，自动生成配送订单，匹配配送车辆，用最优的配送方案，保证客户的库存 在指定范围内。<br>
            例如：<br>
            车容量：13t<br>
            客户A：最大库存量8t&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;每天销量：8t<br>
            客户B：最大库存量10t&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;每天销量：5t
          </div>
          <div class="content-4-text-img">
            <img src="~assets/index/c4-4.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="index-content-5">
      <div class="index-content-5-text">
        <div class="logo-img">
          <img src="~assets/logo-s.png" alt="">
        </div>
        <div class="logo-c-info">
          <span>邮箱：info@reemii.cn</span><br>
          <span>电话: 0871-64589278</span>
        </div>
        <div class="logo-c-info">
          <span>官网：http://www.reemii.cn</span><br>
          <span>地址：昆明市西山区红星财富中心B座28楼</span>
        </div>
        <div class="logo-c-qr">
          <img src="~assets/index/qr.png" alt=""><br>
          <span>扫一扫更精彩</span>
        </div>
      </div>
    </div>
    </template>
    <router-view></router-view v-else>
  </div>
</template>

<script>
  import PageHead from '../components/PageHead'
  export default {
    components: {
      page_head: PageHead
    },
    methods: {
      goSingle () {
        this.$router.push({name: 'single_home'})
      },
      gowork () {
        this.$router.push({name: 'home_base'})
      }
    },
    computed: {
      path: {
        get () {
          return this.$store.state.route.path
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../style/base.less';
  .logo-c-qr {
    text-align: center;
    img {
      width: 8.5em;
    }
  }
  .logo-img {
    padding-bottom: 2.7em;
    img {
      width: 18em;
    }
  }
  .content-4-text-note-2 {
    height: 13em !important;
  }
  .content-4-text-note {
    display: flex;
    font-size: 1.2em;
    color: #58585a;
    align-items: center;
    line-height: 1.7;
    height: 7em;
  }
  .content-4-text-title {
    display: flex;
    div {
      display: flex;
      background: #0c63aa;
      color:#fff;
      height: 2.4em;
      align-items: center;
      padding: 0 1em;
      border-top-left-radius: 1.5em;
      border-bottom-right-radius: 1.5em;
      span {
        font-size: 1em;
      }
      .big-text span {
        font-size: 1.3em;
      }
    }
  }
  .content-4-text-img {
    img {
      width: 37.8em;
    }
  }
  .content-4-text-line {
    width: 1em;
  }
  .content-4-text-c {
    width: 37.9em;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .index-content-line {
    height: 3px;
    background-image:linear-gradient(to left,rgba(220, 220, 220, 1),#162952,rgba(220, 220, 220, 1));
  }
  .content-3-text {
    border-radius: 6.4em;
    padding: 0 3em;
    width: 80em;
    height: 12.7em;
    border: 3px solid #ccc;
    display: flex;
    justify-content: space-between;
    div {
      display: flex;
      align-items: center;
    }
    img {
      width: 9.6em;
    }
  }
  .content-4-text {
    display: flex;
    width: 80em;
    justify-content:  space-between;
    margin-bottom: 3em;
  }
  .home-page-index {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .img-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    span {
      font-size: 1.5em;
      color: #fff;
      line-height: 2.5;
    }
  }
  .top-img {
    background:url('~assets/index/bak1.png');
    background-repeat: no-repeat;
    background-size: 100% 100%, auto;
    height: 60em;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .top-img-content {
    margin-top: 3em;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }
  .top-img-content-text {
    font-size: 2em;
    color: #fff;
    font-weight: 600;
  }
  .top-img-content-btn {
    height: 1.6em;
    align-items: center;
    justify-content: center;
    width: 6.8em;
    align-self:center;
    display: flex;
    background: #00ccff;
    border-radius: 0.5em;
    margin-top: 0.8em;
    color: #081633;
    font-size: 2em;
    font-weight: 800;
  }
  .content-1-text-2 {
    padding: 1.25em 0 2.3em;
    letter-spacing: 0.1em;
    text-align: center;
  }
  .index-content-1 {
    background: #fff;
    align-items: center;
    display: flex;
    flex-direction: column;
  }
  .index-content-2 {
    background: #162952;
    align-items: center;
    display: flex;
    flex-direction: column;
  }
  .index-content-3 {
    padding-bottom: 1.9em;
    background-image:linear-gradient(to left,rgba(239, 239, 239, 0.1),rgba(239, 239, 239, 1),rgba(239, 239, 239, 1),rgba(239, 239, 239, 0.1));
    align-items: center;
    display: flex;
    flex-direction: column;
  }
  .index-content-4 {
    background-color: #fff;
    align-items: center;
    display: flex;
    flex-direction: column;
  }
  .index-content-5 {
    justify-content: center;
    display: flex;
    height: 13em;
    background-color: #081633;
  }
  .index-content-5-text {
    justify-content:  space-between;
    display: flex;
    align-items:center;
    width: 70em;
    height: 13em;
    span {
      font-size: 1.13em;
      color: #717171;
    }
  }
  .content-1-title {
    margin: 1.67em 0;
    color: #081633;
    letter-spacing: 2px;
    font-size: 1.88em;
  }
  .content-1-title {
    margin: 1.67em 0;
    letter-spacing: 2px;
    font-size: 1.88em;
  }
  .content-2-title {
    margin: 2.2em 0 1.2em;
    color: #fff;
    letter-spacing: 2px;
    font-size: 1.88em;
  }
  .content-3-title {
    margin: 2.2em 0 1.2em;
    color: #081633;
    letter-spacing: 2px;
    font-size: 1.88em;
  }
  .content-4-title {
    margin: 1.9em 0 1.5em;
    color: #081633;
    letter-spacing: 2px;
    font-size: 1.88em;
  }
  .conten-2-right {
    padding-left:8em;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .content-2-text {
    display: flex;
  }
  .content-1-text {
    width: 85%;
    display: flex;
    font-size: 1.5em;
    color: #58585a;
    div {
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;
    }
  }
  .conten-2-right-c {
    display: flex;
    strong {
      font-size: 4em;
      color: #fff;
      padding: 0.3em 0.2em 0;
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?056003f0